import React, {useEffect, useState} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import axios from 'axios';
import AuthLayout from 'components/AuthLayout';
import Button from 'components/button';

const STATUS = {
    LOADING: 'loading',
    VALID: 'valid',
    EXPIRED: 'expired',
    USED: 'used',
    NOT_FOUND: 'not_found',
    ERROR: 'error',
};

const Invite = () => {
    const {token} = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState(STATUS.LOADING);
    const [invitationData, setInvitationData] = useState(null);

    useEffect(() => {
        if (!token) {
            setStatus(STATUS.NOT_FOUND);
            return;
        }

        axios.get(`${process.env.REACT_APP_API_URL}invitation/verify/${token}`)
            .then(res => {
                setInvitationData(res.data);
                setStatus(STATUS.VALID);
            })
            .catch(err => {
                const code = err.response?.status;
                if (code === 410) setStatus(STATUS.EXPIRED);
                else if (code === 400) setStatus(STATUS.USED);
                else if (code === 404) setStatus(STATUS.NOT_FOUND);
                else setStatus(STATUS.ERROR);
            });
    }, [token]);

    const handleRegister = () => {
        navigate(`/register/interimaire?invite=${token}`);
    };

    const handleLogin = () => {
        navigate('/login/interimaire');
    };

    if (status === STATUS.LOADING) {
        return (
            <AuthLayout>
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-yellow-500"></div>
                <p className="text-gray-500 text-sm tab:text-base">Vérification de l'invitation...</p>
            </AuthLayout>
        );
    }

    if (status === STATUS.VALID) {
        const greeting = invitationData?.firstname
            ? `Bonjour ${invitationData.firstname},`
            : 'Bonjour,';

        return (
            <AuthLayout>
                <div className="text-left flex flex-col gap-2">
                    <h1 className="text-2xl tab:text-3xl font-medium text-[#111827]">
                        {greeting}
                    </h1>
                    <p className="text-gray-500 text-sm tab:text-base">
                        Invitation Jobbiz suite à un JobDating — créez votre compte pour accéder aux missions.
                    </p>
                </div>
                <div className="space-y-4 w-full min-w-0">
                    {invitationData?.email && (
                        <div className="bg-gray-100 rounded-lg p-3 flex items-center gap-2">
                            <span className="text-xs text-gray-500">Email :</span>
                            <span className="text-sm text-gray-900 font-medium">{invitationData.email}</span>
                        </div>
                    )}
                    <Button size={'FULL'} onClick={handleRegister}>
                        Créer mon compte
                    </Button>
                </div>
            </AuthLayout>
        );
    }

    const errorConfig = {
        [STATUS.EXPIRED]: {
            title: 'Invitation expirée',
            message: 'Cette invitation a expiré. Contactez votre recruteur pour en recevoir une nouvelle.',
            icon: '⏰',
        },
        [STATUS.USED]: {
            title: 'Invitation déjà utilisée',
            message: 'Cette invitation a déjà été utilisée. Si vous avez déjà un compte, connectez-vous.',
            icon: '✅',
        },
        [STATUS.NOT_FOUND]: {
            title: 'Invitation introuvable',
            message: "Ce lien d'invitation n'est pas valide. Vérifiez que vous avez copié le lien complet.",
            icon: '🔍',
        },
        [STATUS.ERROR]: {
            title: 'Erreur',
            message: "Une erreur est survenue lors de la vérification de l'invitation. Réessayez plus tard.",
            icon: '⚠️',
        },
    };

    const config = errorConfig[status] || errorConfig[STATUS.ERROR];

    return (
        <AuthLayout>
            <div className="text-left flex flex-col gap-2">
                <h1 className="text-2xl tab:text-3xl font-medium text-[#111827]">
                    {config.title}
                </h1>
                <p className="text-gray-500 text-sm tab:text-base">
                    {config.message}
                </p>
            </div>
            <div className="flex flex-col gap-3 w-full min-w-0">
                <Button size={'FULL'} onClick={handleLogin}>
                    Se connecter
                </Button>
                <Button size={'FULL'} color={'SECONDARY'} onClick={() => navigate('/register/interimaire')}>
                    S'inscrire
                </Button>
            </div>
        </AuthLayout>
    );
};

export default Invite;
